import { Role } from "../domain/enums/RoleEnum";
import { IFileDTO } from "../domain/models/dto/FileDTO";
import { UserDTO } from "../domain/models/dto/UserDTO";
import { User } from "../domain/models/User";
import { BaseModelImpl } from "./BaseModelImpl";

export default class UserModel extends BaseModelImpl<UserDTO> implements User {
    constructor(data?: UserDTO) {
        super();
        this.assignData(data);
    }

    id?: string;
    firstName: string = "";
    lastName: string = "";
    middleName: string;
    email: string;
    phone?: string;
    roleId: Role;
    rating?: string;
    description?: string
    position?: string;
    files?: IFileDTO[];

    get fullName(): string {
        return `${this.firstName} ${this.lastName}`.trim();
    }

    get isSuperAdmin(): boolean {
        return this.roleId === Role.SUPER_ADMIN;
    }
}
